<script setup>
import { PrimaryButton, SecondaryButton } from "@Components/Button";
import Tooltip from "@Components/Tooltip.vue";
import { computed } from "vue";

const props = defineProps({
    action: {
        type: Object,
        required: true,
    },
    params: {
        type: Object,
    },
});

const disabled = computed(() => {
    if (props.action.options.disabled) {
        if (typeof props.action.options.disabled === "function") {
            return props.action.options.disabled(props.action);
        }
        return props.action.options.disabled;
    }

    return false;
});

defineEmits(["click"]);
</script>

<template>
    <component :is="action.getTooltip(params) ? Tooltip : 'div'" :content="action.getTooltip(params)" tag="div">
        <component
            :disabled="disabled"
            :is="action.options.style === 'primary' ? PrimaryButton : SecondaryButton"
            :icon="action.options.icon"
            :processing="action.getProcessing()"
            @click.prevent="$emit('click')"
            :class="[disabled ? 'opacity-50' : '']">
            <template v-if="action.options.label">{{ action.getLabel(params) }}</template>
        </component>
    </component>
</template>
